import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import PayerPhoneInput from "../inputs/PayerPhoneInput";
import TextInput from "../inputs/TextInput";
import { useSchoolFee } from "../../context/schoolFeeContext";
import { emailRegex } from "../../constants";

/**
 * How the payer pays, and where their receipt goes.
 *
 * PAY-08: the mobile-money number is mandatory. Email is OPTIONAL and blank
 * must not block a payment -- but a school-fee payer is ANONYMOUS, with no
 * customer record to fall back on, so leaving it blank means no emailed
 * receipt at all. The screen says so rather than letting the payer discover it
 * afterwards.
 *
 * ⛔ There is no second phone number (D-31). One number: the account charged.
 */
const SchoolFeeContactStep = () => {
  const { t } = useTranslation();
  const { email, setEmail } = useSchoolFee();

  const emailInvalid = email.trim() !== "" && !emailRegex.test(email.trim());

  return (
    <Box>
      <Typography variant="h6" fontWeight="bold" mb={2}>
        {t("schoolfee.contact.title")}
      </Typography>

      <PayerPhoneInput />

      <Box mb={2}>
        <TextInput
          fullWidth
          type="email"
          id="schoolfee-email"
          label={t("schoolfee.contact.email_label")}
          value={email}
          onChange={event => setEmail(event.target.value)}
          error={emailInvalid}
          helperText={
            emailInvalid
              ? t("schoolfee.contact.email_invalid")
              : t("schoolfee.contact.email_optional_hint")
          }
          variant="outlined"
        />
      </Box>
    </Box>
  );
};

export default SchoolFeeContactStep;
